// Экран «Справка» («Как считаются сроки») — семнадцатый экран нового фронта
// (п.20, 2026-09-07). Текст статический и живёт отдельным файлом `src/wiki.html`,
// перенесённым из оболочки дословно: правится он вместе с ядром (правило CLAUDE.md
// «правишь ядро — правь вики в том же коммите»), поэтому держим его одним куском,
// а не переписываем в разметку компонента.
import wiki from '../wiki.html?raw';

export function Wiki() {
  // содержимое своё, не пользовательское — вставляем как есть
  return <div dangerouslySetInnerHTML={{ __html: wiki }} />;
}
